import { databaseState } from './state';

(window as any).databaseState = databaseState;
